import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const exportMonthlyReportToExcel = (data, month, year) => {
  const wsData = [];

  // === Title Row (spread across 17 columns) ===
  const title = `Monthly Progress Report Stating Recovery Of Loan For the Month of ${month} - ${year}`;
  const columnCount = 17;
  const titleRow = new Array(columnCount).fill("");
  titleRow[0] = title;
  wsData.push(titleRow);

  wsData.push([]); // Empty row after title

  // === Header Row 1: Group Headings ===
  wsData.push([
    "Sl. No.",
    "Division",
    "Department Loan",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "Revolving Fund",
    "",
    "",
    "",
    "",
    "",
    "",
  ]);

  // === Header Row 2: Sub-Headers ===
  wsData.push([
    "",
    "",

    // Department Loan subheaders
    "No. of TAP villages",
    "Year Of Disbursement of Loan",
    "Total amount of loan disbursed",
    "No. of beneficiaries",
    "Amount recovered upto previous month",
    "Amount recovered during the month",
    "Amount recovered upto end of month",
    "% of Loan Recovered",

    // Revolving Fund subheaders
    "Total amount of loan given from RF",
    "No. of beneficiaries",
    "Amount recovered upto previous month",
    "Amount recovered during the month",
    "Amount recovered upto end of month",
    "% of Loan Recovered",
    "% of RF Loan Given",
  ]);

  // === Data Rows ===
  data.forEach((row, idx) => {
    wsData.push([
      idx + 1,
      row.division,
      row.tavVillages,
      row.financialYear,
      row.deptLoanAmount,
      row.deptBeneficiaries,
      row.deptRecoveredPrev,
      row.deptRecoveredThisMonth,
      row.deptRecoveredTotal,
      row.deptRecoveryPercent,

      row.rfLoanAmount,
      row.rfBeneficiaries,
      row.rfRecoveredPrev,
      row.rfRecoveredThisMonth,
      row.rfRecoveredTotal,
      row.rfRecoveryPercent,
      row.rfLoanGivenPercent,
    ]);
  });

  const ws = XLSX.utils.aoa_to_sheet(wsData);

  // === Merge Cells ===
  ws["!merges"] = [
    // Title merge (A1 to Q1)
    { s: { r: 0, c: 0 }, e: { r: 0, c: columnCount - 1 } },

    // Header merges
    { s: { r: 2, c: 0 }, e: { r: 3, c: 0 } }, // Sl. No.
    { s: { r: 2, c: 1 }, e: { r: 3, c: 1 } }, // Division
    { s: { r: 2, c: 2 }, e: { r: 2, c: 9 } }, // Department Loan
    { s: { r: 2, c: 10 }, e: { r: 2, c: 16 } }, // Revolving Fund
  ];

  // === Optional: Column Widths ===
  ws["!cols"] = new Array(17).fill({ wch: 20 });

  // === Center align the merged title (A1) ===
  if (ws["A1"]) {
    ws["A1"].s = {
      alignment: { horizontal: "center", vertical: "center" },
      font: { bold: true, sz: 14 },
    };
  }

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Monthly Report");

  const excelBuffer = XLSX.write(wb, {
    bookType: "xlsx",
    type: "array",
    cellStyles: true, // applies only if you use SheetJS Pro or xlsx-style
  });

  const fileName = `Monthly_Loan_Report_${month}_${year}.xlsx`;
  saveAs(
    new Blob([excelBuffer], { type: "application/octet-stream" }),
    fileName
  );
};

export const exportMonthlyVFCReportToExcel = (data, month, year) => {
  const wsData = [];

  const title = `Monthly VFC Functioning Report for the Month of ${month} - ${year}`;
  const columnCount = 10;
  const titleRow = new Array(columnCount).fill("");
  titleRow[0] = title;
  wsData.push(titleRow);
  wsData.push([]); // Empty row

  // === Header Row 1: Group Headings ===
  wsData.push([
    "Sl. No.",
    "Division",
    "Total No. of VFCs",
    "Meetings Held",
    "Audit Conducted",
    "Benefit Sharing Initiated",
    "Recovery During the Month",
    "Total Recovery Upto the Month",
    "Loan Recovery %",
    "Remarks",
  ]);

  // === Data Rows ===
  data.forEach((row, idx) => {
    wsData.push([
      idx + 1,
      row.division || "-",
      row.totalVFCs || 0,
      row.meetingsHeld || 0,
      row.auditConducted || 0,
      row.benefitSharing || 0,
      row.recoveryDuringMonth || 0,
      row.totalRecovery || 0,
      row.loanRecoveryPercent !== undefined
        ? `${row.loanRecoveryPercent.toFixed(2)}%`
        : "0%",
      row.remarks || "",
    ]);
  });

  const ws = XLSX.utils.aoa_to_sheet(wsData);

  // === Merge title row
  ws["!merges"] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: columnCount - 1 } }, // Merge A1 to J1
  ];

  // Optional: Set column widths
  ws["!cols"] = [
    { wch: 8 }, // Sl. No.
    { wch: 20 }, // Division
    { wch: 18 }, // Total No. of VFCs
    { wch: 15 }, // Meetings Held
    { wch: 15 }, // Audit Conducted
    { wch: 20 }, // Benefit Sharing
    { wch: 22 }, // Recovery During Month
    { wch: 22 }, // Total Recovery
    { wch: 18 }, // Loan Recovery %
    { wch: 25 }, // Remarks
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Monthly VFC Report");

  const excelBuffer = XLSX.write(wb, {
    bookType: "xlsx",
    type: "array",
  });

  const fileName = `Monthly_VFC_Report_${month}_${year}.xlsx`;
  saveAs(
    new Blob([excelBuffer], { type: "application/octet-stream" }),
    fileName
  );
};

export const exportMonthlyVfcReportToExcel = (data, month, year) => {
  const wsData = [];

  const columnCount = 16;
  const title = `Monthly VFC Report for ${month} - ${year}`;
  const titleRow = new Array(columnCount).fill("");
  titleRow[0] = title;
  wsData.push(titleRow);
  wsData.push([]); // empty row

  // Header Rows (2-levels)
  wsData.push([
    "Sl. No.",
    "Division",
    "Name and year of village",
    "VFC meeting",
    "",
    "EC meeting",
    "",
    "Amount available in VFDF as on date (Rs)",
    "Whether statutory audit done & accounts filed (yes / no)",
    "Loan Recovery",
    "",
    "",
    "Protection to forests by VFC",
    "Benefit sharing",
    "",
    "Remarks of the CF",
  ]);

  wsData.push([
    "",
    "",
    "",
    "Date of previous meeting",
    "Date of latest meeting",
    "No. of EC meetings held",
    "Date of latest EC meeting",
    "",
    "",
    "Department loan given",
    "% of recovery",
    "Amount Revolved",
    "",
    "Whether NTFP shared",
    "Value of product shared",
    "",
  ]);

  // Data Rows
  data.forEach((row, index) => {
    wsData.push([
      index + 1,
      row.division || "-",
      row.villageNameYear || "-",
      row.previousMeetingDate
        ? new Date(row.previousMeetingDate).toLocaleDateString("en-IN")
        : "-",
      row.latestMeetingDate
        ? new Date(row.latestMeetingDate).toLocaleDateString("en-IN")
        : "-",
      row.ecMeetingCount ?? "-",
      row.latestEcMeetingDate
        ? new Date(row.latestEcMeetingDate).toLocaleDateString("en-IN")
        : "-",
      row.vfdfBalance?.toLocaleString("en-IN") ?? "-",
      row.auditStatus ? "Yes" : "No",
      row.deptLoanAmount?.toLocaleString("en-IN") ?? "-",
      row.deptRecoveryPercent ?? "-",
      row.revolvingLoanAmount?.toLocaleString("en-IN") ?? "-",
      row.protectionStatus || "-",
      row.ntfpShared ? "Yes" : "No",
      row.ntfpSharedValue?.toLocaleString("en-IN") ?? "-",
      row.cfRemarks || "-",
    ]);
  });

  const ws = XLSX.utils.aoa_to_sheet(wsData);

  // Merges
  ws["!merges"] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: columnCount - 1 } },
    { s: { r: 2, c: 0 }, e: { r: 3, c: 0 } },
    { s: { r: 2, c: 1 }, e: { r: 3, c: 1 } },
    { s: { r: 2, c: 2 }, e: { r: 3, c: 2 } },
    { s: { r: 2, c: 3 }, e: { r: 2, c: 4 } },
    { s: { r: 2, c: 5 }, e: { r: 2, c: 6 } },
    { s: { r: 2, c: 7 }, e: { r: 3, c: 7 } },
    { s: { r: 2, c: 8 }, e: { r: 3, c: 8 } },
    { s: { r: 2, c: 9 }, e: { r: 2, c: 11 } },
    { s: { r: 2, c: 12 }, e: { r: 3, c: 12 } },
    { s: { r: 2, c: 13 }, e: { r: 2, c: 14 } },
    { s: { r: 2, c: 15 }, e: { r: 3, c: 15 } },
  ];

  // Set column widths
  ws["!cols"] = new Array(columnCount).fill({ wch: 25 });

  // Add center alignment to title and header cells
  const centerAlign = {
    alignment: { horizontal: "center", vertical: "center", wrapText: true },
  };

  // Title cell (row 0)
  for (let c = 0; c < columnCount; c++) {
    const cell = ws[XLSX.utils.encode_cell({ r: 0, c })];
    if (cell) cell.s = centerAlign;
  }

  // Header rows (row 2 and 3)
  for (let r = 2; r <= 3; r++) {
    for (let c = 0; c < columnCount; c++) {
      const cell = ws[XLSX.utils.encode_cell({ r, c })];
      if (cell) cell.s = centerAlign;
    }
  }

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Monthly VFC Report");

  const excelBuffer = XLSX.write(wb, {
    bookType: "xlsx",
    type: "array",
    cellStyles: true, // Enable styles
  });

  const fileName = `Monthly_VFC_Report_${month}_${year}.xlsx`;
  saveAs(
    new Blob([excelBuffer], { type: "application/octet-stream" }),
    fileName
  );
};
const formatTitles = {
  "Format-I": "FORMAT I",
  "Format-II": "FORMAT II",
  "Format-III": "FORMAT III",
  "Format-IIIA": "FORMAT IIIA",
  "Format-IV": "FORMAT IV",
};

const subTitles = {
  "Format-III": "Line department activities done", // or your specific text
  "Format-IIIA":
    "Line department activities done under Health and Veterinary camps",
};

export const handleExportSingleFormat = (formatName, data) => {
  const wsData = [];
  const merges = [];

  const columnCount = getColumnCount(formatName);

  // Title row (merged)
  const titleRow = new Array(columnCount).fill("");
  titleRow[0] = formatTitles[formatName] || formatName;
  wsData.push(titleRow);
  merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: columnCount - 1 } });

  // Subtitle row (merged if exists)
  let subtitleOffset = 1;
  const subtitle = subTitles[formatName];
  if (subtitle) {
    const subtitleRow = new Array(columnCount).fill("");
    subtitleRow[0] = subtitle;
    wsData.push(subtitleRow);
    merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: columnCount - 1 } });
    subtitleOffset++;
  }

  wsData.push([]); // spacer row
  subtitleOffset++;

  const { headers, rows } = formatDataForExport(formatName, data);
  wsData.push(...headers);
  wsData.push(...rows);

  const ws = XLSX.utils.aoa_to_sheet(wsData);
  ws["!merges"] = merges;
  // ✨ Apply center alignment and bold to column headers
  if (headers && headers.length > 0) {
    headers.forEach((headerRow, headerRowIndex) => {
      headerRow.forEach((_, colIdx) => {
        const cellRef = XLSX.utils.encode_cell({
          r: subtitleOffset + headerRowIndex,
          c: colIdx,
        });
        const cell = ws[cellRef];
        if (cell) {
          cell.s = {
            alignment: { horizontal: "center", vertical: "center" },
            font: { bold: true },
          };
        }
      });
    });
  }
  // Special merging for Format-IIIA header
  if (formatName === "Format-IIIA") {
    ws["!merges"].push(
      { s: { r: subtitleOffset, c: 4 }, e: { r: subtitleOffset, c: 6 } }, // No. of Persons Benefited
      { s: { r: subtitleOffset, c: 0 }, e: { r: subtitleOffset + 1, c: 0 } },
      { s: { r: subtitleOffset, c: 1 }, e: { r: subtitleOffset + 1, c: 1 } },
      { s: { r: subtitleOffset, c: 2 }, e: { r: subtitleOffset + 1, c: 2 } },
      { s: { r: subtitleOffset, c: 3 }, e: { r: subtitleOffset + 1, c: 3 } },
      { s: { r: subtitleOffset, c: 7 }, e: { r: subtitleOffset + 1, c: 7 } },
      { s: { r: subtitleOffset, c: 8 }, e: { r: subtitleOffset + 1, c: 8 } },
      { s: { r: subtitleOffset, c: 9 }, e: { r: subtitleOffset + 1, c: 9 } },
      { s: { r: subtitleOffset, c: 10 }, e: { r: subtitleOffset + 1, c: 10 } }
    );
  }

  // Center-align title & subtitle
  [0, 1].forEach((rowIdx) => {
    const cell = ws[XLSX.utils.encode_cell({ r: rowIdx, c: 0 })];
    if (cell) {
      cell.s = {
        alignment: { horizontal: "center" },
        font: { bold: true, sz: rowIdx === 0 ? 14 : 12 },
      };
    }
  });

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, formatName);
  XLSX.writeFile(wb, `${formatName}.xlsx`);
};

export const handleExportAllFormats = (allData, year, halfYear) => {
  if (!allData || typeof allData !== "object") {
    console.error("Invalid data passed to export:", allData);
    return;
  }

  const formats = Object.keys(allData);
  const wb = XLSX.utils.book_new();

  formats.forEach((formatName) => {
    const formatData = allData[formatName];
    if (!Array.isArray(formatData) || formatData.length === 0) return;

    const wsData = [];
    const merges = [];

    const columnCount = getColumnCount(formatName);

    // Title
    const titleRow = new Array(columnCount).fill("");
    titleRow[0] = formatTitles[formatName] || formatName;
    wsData.push(titleRow);
    merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: columnCount - 1 } });

    // Subtitle
    let subtitleOffset = 1;
    const subtitle = subTitles[formatName];
    if (subtitle) {
      const subtitleRow = new Array(columnCount).fill("");
      subtitleRow[0] = subtitle;
      wsData.push(subtitleRow);
      merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: columnCount - 1 } });
      subtitleOffset++;
    }

    wsData.push([]); // spacer row
    subtitleOffset++;

    // ✅ FIXED: Pass only format-specific data
    const { headers, rows } = formatDataForExport(formatName, formatData);
    wsData.push(...headers);
    wsData.push(...rows);

    const ws = XLSX.utils.aoa_to_sheet(wsData);
    ws["!merges"] = merges;
    // ✨ Apply center alignment and bold to column headers
    if (headers && headers.length > 0) {
      headers.forEach((headerRow, headerRowIndex) => {
        headerRow.forEach((_, colIdx) => {
          const cellRef = XLSX.utils.encode_cell({
            r: subtitleOffset + headerRowIndex,
            c: colIdx,
          });
          const cell = ws[cellRef];
          if (cell) {
            cell.s = {
              alignment: { horizontal: "center", vertical: "center" },
              font: { bold: true },
            };
          }
        });
      });
    }
    if (formatName === "Format-IIIA") {
      ws["!merges"].push(
        { s: { r: subtitleOffset, c: 4 }, e: { r: subtitleOffset, c: 6 } }, // Persons Benefited
        { s: { r: subtitleOffset, c: 0 }, e: { r: subtitleOffset + 1, c: 0 } },
        { s: { r: subtitleOffset, c: 1 }, e: { r: subtitleOffset + 1, c: 1 } },
        { s: { r: subtitleOffset, c: 2 }, e: { r: subtitleOffset + 1, c: 2 } },
        { s: { r: subtitleOffset, c: 3 }, e: { r: subtitleOffset + 1, c: 3 } },
        { s: { r: subtitleOffset, c: 7 }, e: { r: subtitleOffset + 1, c: 7 } },
        { s: { r: subtitleOffset, c: 8 }, e: { r: subtitleOffset + 1, c: 8 } },
        { s: { r: subtitleOffset, c: 9 }, e: { r: subtitleOffset + 1, c: 9 } },
        { s: { r: subtitleOffset, c: 10 }, e: { r: subtitleOffset + 1, c: 10 } }
      );
    }

    // Styling titles
    [0, 1].forEach((rowIdx) => {
      const cell = ws[XLSX.utils.encode_cell({ r: rowIdx, c: 0 })];
      if (cell) {
        cell.s = {
          alignment: { horizontal: "center" },
          font: { bold: true, sz: rowIdx === 0 ? 14 : 12 },
        };
      }
    });

    XLSX.utils.book_append_sheet(wb, ws, formatName);
  });

  const filename = `Half_Yearly_Report_${year}_${halfYear === "H1" ? "Jan-Jun" : "Jul-Dec"
    }.xlsx`;

  XLSX.writeFile(wb, filename);
};

const getColumnCount = (formatName) => {
  switch (formatName) {
    case "Format-I":
      return 4;
    case "Format-II":
      return 7;
    case "Format-III":
      return 6;
    case "Format-IIIA":
      return 11;
    case "Format-IV":
      return 8;
    default:
      return 5;
  }
};

const formatDataForExport = (formatName, data) => {
  const headers = [];
  const rows = [];

  switch (formatName) {
    case "Format-I": {
      headers.push([
        "Name of the Division",
        "Name of the District",
        "Year",
        "Name of the Project Village",
      ]);
      data.forEach((r) =>
        rows.push([
          r?.nameOfDivision?.divisionName || "—",
          r?.nameOfDistrict || "—",
          r?.year || "—",
          r?.nameOfProjectVillage?.vfcName || "—",
        ])
      );
      break;
    }
    case "Format-II": {
      headers.push([
        "Year",
        "Name of the Division",
        "Physical Target (Ha./Km)",
        "Achievement (Ha./Km)",
        "Financial Target (Rs. in Lakhs)",
        "Financial Achievement (Rs. in Lakhs)",
        "Dates of Meeting Held Between",
      ]);
      data.forEach((r) =>
        rows.push([
          r?.year || "—",
          r?.nameOfDivision?.divisionName || "—",
          r?.physicalTarget || "—",
          r?.achievement || "—",
          r?.financialTarget || "—",
          r?.financialAchievement || "—",
          r?.meetingDates || "—",
        ])
      );
      break;
    }
    case "Format-III": {
      headers.push([
        "Name of the Division",
        "Year",
        "Name of the TAP Village",
        "Name of the Work Done",
        "Name of the Department Involved",
        "Amount Spent (in Lakhs)",
      ]);
      data.forEach((r) =>
        rows.push([
          r?.nameOfDivision?.divisionName || "—",
          r?.year || "—",
          r?.nametapVillage?.vfcName || "—",
          r?.workDone || "—",
          r?.departmentInvolved || "—",
          r?.amountSpent ?? "—",
        ])
      );
      break;
    }
    case "Format-IIIA": {
      // First merged title row (Excel will merge this via ws["!merges"])
      headers.push([
        "Name of the Division",
        "Year",
        "Name of the TAP Village",
        "No. of Medical Camp Held",
        "No. of Persons Benefited", // sub-columns of "No. of Persons Benefited"
        "",
        "",
        "Name of the Department Involved",
        "No. of Veterinary Camps Held",
        "No. of Cattle Benefited",
        "Name of Line Department Involved",
      ]);

      // Add a second row that maps to merged headers (simulate the merged layout visually)
      const secondHeaderRow = [
        "",
        "",
        "",
        "", // for first 4 columns (not merged)
        "Male",
        "Female",
        "Total",
        "",
        "",
        "",
        "",
      ];
      headers.splice(1, 0, secondHeaderRow); // ✅ Insert after title row, before actual headers

      // Then add rows
      data.forEach((r) =>
        rows.push([
          r?.nameOfDivision?.divisionName || "—",
          r?.year || "—",
          r?.nametapVillage?.vfcName || "—",
          r?.medicalCampCount ?? "—",
          r?.beneficiariesMale ?? "—",
          r?.beneficiariesFemale ?? "—",
          r?.beneficiariesTotal ?? "—",
          r?.departmentInvolved || "—",
          r?.vetCampsHeld ?? "—",
          r?.cattleBenefited ?? "—",
          r?.lineDepartmentInvolved || "—",
        ])
      );
      break;
    }

    case "Format-IV": {
      headers.push([
        "Name of the Division",
        "Year",
        "Name of the TAP Village",
        "Panchayat",
        "Work Pending",
        "Reason for Delay",
        "Amount (in Lakhs)",
        "Order Awaited From Department",
      ]);
      data.forEach((r) =>
        rows.push([
          r?.nameOfDivision?.divisionName || "—",
          r?.year || "—",
          r?.nametapVillage?.vfcName || "—",
          r?.panchayat || "—",
          r?.workPending || "—",
          r?.reasonForDelay || "—",
          r?.amount ?? "—",
          r?.orderAwaitedFromDept || "—",
        ])
      );
      break;
    }
    default:
      break;
  }

  return { headers, rows };
};



/**
 * Helper groupBy
 */
const groupBy = (arr = [], key) =>
  arr.reduce((acc, item) => {
    const g = item[key] ?? "Unknown";
    if (!acc[g]) acc[g] = [];
    acc[g].push(item);
    return acc;
  }, {});

export const exportRangeWiseReport = (report) => {
  if (!report || !Array.isArray(report) || report.length === 0) return;

  const sortedReport = [...report].sort((a, b) =>
    String(a.circle || "").localeCompare(String(b.circle || ""))
  );

  const circleGroups = groupBy(sortedReport, "circle");

  const wb = XLSX.utils.book_new();

  // 🔥 STEP 1: GET GLOBAL LOAN TYPES
  const allLoanTypes = [
    ...new Set(
      sortedReport.flatMap(r =>
        Object.keys(r.loanTypeTotals || {})
      )
    )
  ];

  const primaryType = allLoanTypes[0] || "Primary Loan";
  const secondaryLabel = "Other Loans";

  // 🔥 HELPER (CORE LOGIC)
  const mapLoanTypes = (loanTypes = {}) => {
    let primary = { loan: 0, recovered: 0 };
    let secondary = { loan: 0, recovered: 0 };

    Object.entries(loanTypes).forEach(([name, val]) => {
      if (name === primaryType) {
        primary.loan += val.loan || 0;
        primary.recovered += val.recovered || 0;
      } else {
        secondary.loan += val.loan || 0;
        secondary.recovered += val.recovered || 0;
      }
    });

    return { primary, secondary };
  };

  Object.entries(circleGroups).forEach(([circleName, circleRanges]) => {

    // 🔥 DYNAMIC HEADER
    const headerRow0 = [
      "Circle",
      "Circle Level", "", "", "", "", "", "",
      "Division",
      "Division Level", "", "", "", "", "", "",
      "Range",
      "Range Level", "", "", "", "", "", "",
      "VFC Name",
      "VFC Year Level", "", "", "", "", "", ""
    ];

    const headerRow1 = [
      "",
      "Total VFC",
      "Total Members",
      "Total Active Loans",
      `Total ${primaryType}`,
      `Total ${primaryType} Recovered`,
      `Total ${secondaryLabel}`,
      `Total ${secondaryLabel} Recovered`,

      "",
      "Total VFC",
      "Total Members",
      "Total Active Loans",
      `Total ${primaryType}`,
      `Total ${primaryType} Recovered`,
      `Total ${secondaryLabel}`,
      `Total ${secondaryLabel} Recovered`,

      "",
      "Total VFC",
      "Total Members",
      "Total Active Loans",
      `Total ${primaryType}`,
      `Total ${primaryType} Recovered`,
      `Total ${secondaryLabel}`,
      `Total ${secondaryLabel} Recovered`,

      "VFC Name",
      "Total Members",
      "Total Active Loans",
      "Year",
      `Total ${primaryType}`,
      `Total ${primaryType} Recovered`,
      `Total ${secondaryLabel}`,
      `Total ${secondaryLabel} Recovered`
    ];

    const wsData = [headerRow0, headerRow1];

    const merges = [
      { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
      { s: { r: 0, c: 1 }, e: { r: 0, c: 7 } },
      { s: { r: 0, c: 8 }, e: { r: 1, c: 8 } },
      { s: { r: 0, c: 9 }, e: { r: 0, c: 15 } },
      { s: { r: 0, c: 16 }, e: { r: 1, c: 16 } },
      { s: { r: 0, c: 17 }, e: { r: 0, c: 23 } },
      { s: { r: 0, c: 24 }, e: { r: 1, c: 24 } },
      { s: { r: 0, c: 25 }, e: { r: 0, c: 31 } }
    ];

    let currentRow = 2;

    const divisionGroups = groupBy(circleRanges, "division");

    Object.entries(divisionGroups).forEach(([divisionName, ranges]) => {

      const divisionStartRow = currentRow;

      ranges.forEach((range) => {

        const vfcList = range.vfcYearWiseReport || [];

        const flatRows = [];

        vfcList.forEach((vfc) => {
          const yrs = vfc.yearlyReport || [];
          if (yrs.length === 0) {
            flatRows.push({ vfcName: vfc.vfcName, yearObj: null });
          } else {
            yrs.forEach((y) => {
              flatRows.push({ vfcName: vfc.vfcName, yearObj: y });
            });
          }
        });

        if (flatRows.length === 0) {
          flatRows.push({ vfcName: "", yearObj: null });
        }

        const rangeStartRow = currentRow;

        flatRows.forEach((fr) => {
          const row = new Array(32).fill("");

          row[0] = circleName;
          row[8] = divisionName;
          row[16] = range.range;

          row[17] = range.totalVFCs;
          row[18] = range.totalMembers;
          row[19] = range.totalLoans;

          const rangeMap = mapLoanTypes(range.loanTypeTotals);
          row[20] = rangeMap.primary.loan;
          row[21] = rangeMap.primary.recovered;
          row[22] = rangeMap.secondary.loan;
          row[23] = rangeMap.secondary.recovered;

          row[24] = fr.vfcName;

          if (fr.yearObj) {
            row[25] = fr.yearObj.totalMembers;
            row[26] = fr.yearObj.totalActiveLoans;
            row[27] = fr.yearObj.year;

            const yearMap = mapLoanTypes(fr.yearObj.loanTypes);

            row[28] = yearMap.primary.loan;
            row[29] = yearMap.primary.recovered;
            row[30] = yearMap.secondary.loan;
            row[31] = yearMap.secondary.recovered;
          }

          wsData.push(row);
          currentRow++;
        });

        if (currentRow - rangeStartRow > 1) {
          for (let c = 16; c <= 23; c++) {
            merges.push({
              s: { r: rangeStartRow, c },
              e: { r: currentRow - 1, c }
            });
          }
        }
      });

      if (currentRow - divisionStartRow > 1) {
        for (let c = 8; c <= 15; c++) {
          merges.push({
            s: { r: divisionStartRow, c },
            e: { r: currentRow - 1, c }
          });
        }
      }
    });

    const ws = XLSX.utils.aoa_to_sheet(wsData);
    ws["!merges"] = merges;
    ws["!cols"] = new Array(32).fill({ wch: 18 });

    XLSX.utils.book_append_sheet(wb, ws, circleName.substring(0, 30));
  });

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  });

  saveAs(blob, "RangeWiseReport.xlsx");
};